import { LocalizedLink as Link } from "./LocalizedLink";
import logoSvg from "@/assets/banana-logo.svg";
import { CountryPicker } from "./CountryPicker";
import { useT } from "@/lib/i18n/dict";
import type { ChromeKey } from "@/lib/i18n/dict";

const COLUMNS: { titleKey: ChromeKey; links: { labelKey: ChromeKey; href: string }[] }[] = [
  {
    titleKey: "footer.col.platform",
    links: [
      { labelKey: "footer.platform.cards", href: "/platform/cards" },
      { labelKey: "footer.platform.ai", href: "/platform/ai" },
      { labelKey: "footer.platform.contacts", href: "/platform/contacts" },
      { labelKey: "footer.platform.bookings", href: "/platform/bookings" },
      { labelKey: "footer.platform.contracts", href: "/platform/contracts" },
      { labelKey: "footer.platform.automations", href: "/platform/automations" },
      { labelKey: "footer.platform.analytics", href: "/platform/analytics" },
    ],
  },
  {
    titleKey: "footer.col.solutions",
    links: [
      { labelKey: "footer.solutions.sales", href: "/solutions/sales" },
      { labelKey: "footer.solutions.founders", href: "/solutions/founders" },
      { labelKey: "footer.solutions.realEstate", href: "/solutions/real-estate" },
      { labelKey: "footer.solutions.enterprise", href: "/solutions/enterprise" },
    ],
  },
  {
    titleKey: "footer.col.company",
    links: [
      { labelKey: "footer.company.about", href: "/about" },
      { labelKey: "footer.company.pricing", href: "/pricing" },
      { labelKey: "footer.company.shop", href: "/shop" },
      { labelKey: "footer.company.contact", href: "/contact" },
    ],
  },
  {
    titleKey: "footer.col.resources",
    links: [
      { labelKey: "footer.resources.help", href: "/help" },
      { labelKey: "footer.resources.articles", href: "/articles" },
      { labelKey: "footer.resources.legal", href: "/legal" },
      { labelKey: "footer.resources.security", href: "/security" },
      { labelKey: "footer.resources.antiSpam", href: "/legal/anti-spam" },
      { labelKey: "footer.resources.returns", href: "/legal/returns" },
    ],
  },
];

export function Footer() {
  const t = useT();
  return (
    <footer className="mt-12 bg-black text-background sm:mt-16 md:mt-20">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:py-14 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_3fr]">
          <div>
            <img src={logoSvg} alt="banana.cards" width={138} height={24} className="h-6 w-auto brightness-0 invert" />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background/70">
              {t("footer.tagline")}
            </p>
            <div className="mt-6"><CountryPicker /></div>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
            {COLUMNS.map((col) => (
              <div key={col.titleKey}>
                <p className="text-xs font-bold uppercase tracking-wider text-background/50">{t(col.titleKey)}</p>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.href}>
                      <Link
                        to={l.href}
                        className="text-sm text-background/85 transition hover:text-brand-lime"
                      >
                        {t(l.labelKey)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-background/10 pt-6 text-xs text-background/60 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} banana.cards. {t("footer.copyright")}</p>
          <p>{t("footer.madeWith")}</p>
        </div>
      </div>
    </footer>
  );
}
